import { ENUM_DEVICE_ORIENTATION } from "../store/deviceSizeSlice";
import { useAppSelector } from "../store/index.ts";

export default function useDeviceOrientation() {
  const orientation = useAppSelector((state) => state.deviceSize.orientation);
  const isHorizontal = orientation === ENUM_DEVICE_ORIENTATION.landscape;
  const isVertical = orientation === ENUM_DEVICE_ORIENTATION.portrait;
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);

  const isMobileHorizontal = isMobile && isHorizontal;
  const isMobileVertical = isMobile && isVertical;

  return { orientation, isHorizontal, isVertical, isMobileHorizontal, isMobileVertical };
}
